// extracted by css-extract-rspack-plugin
export default {"arrowLeft":"_353c018b","arrowRight":"_433fb4f0"};